import { useCallback, useEffect } from "react";
import { trackPromise } from "react-promise-tracker";
import { useWaybillResolver } from "../../../../../../hooks/useWaybillResolver";
import { useOperationStore } from "../../../../../../stores/OperationStore";

function InitialHook() {

    const waybillNo = useWaybillResolver();

    const GetManifestDetailsAction = useOperationStore((state) => state?.GetManifestDetailsAction);

    const initialService = useCallback(() => {
        trackPromise(GetManifestDetailsAction(waybillNo), 'manifest-initial-area');
    }, [GetManifestDetailsAction, waybillNo])

    useEffect(() => {
        initialService();
    }, [initialService])

    const onRefreshHandler = () => {
        initialService()
    }

    return {
        onRefreshHandler
    }

}

export default InitialHook